import { rootApi } from '../rootApi';

export const bulletinDocumentApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getBulletinFileList: builder.query({
            query: (bulletId) => ({
                url: 'v1/bulletin/list',
                method: 'GET',
                params: { bulletId }
            }),
            providesTags: (result, error, bulletId) => [{ type: 'BulletinDocuments', id: bulletId }]
        }),

        downloadBulletinFile: builder.query({
            query: ({ bulletId, fileName }) => ({
                url: 'v1/bulletin/download',
                method: 'GET',
                params: { bulletId, fileName },
                responseHandler: async (response) => {
                    if (!response.ok) {
                        const errorData = await response.json();
                        throw new Error(errorData.message || 'Download failed');
                    }
                    const blob = await response.blob();
                    const contentDisposition = response.headers.get('content-disposition');
                    return { blob, contentDisposition, fileName };
                },
                cache: 'no-cache'
            })
        })
    })
});

export const {
    useGetBulletinFileListQuery,
    useLazyDownloadBulletinFileQuery
} = bulletinDocumentApi;
